import React, { useEffect, VFC } from 'react';
import useIsMounted from 'ismounted';

import { UsersitePlansGetManyPlansTypePayload } from '~/models/schema';
import { ArticleProps } from '~/src/core/Articles/props';
import { Props as HeaderProps } from '../../components/Header';
import TopComponent from './template';

export type Plan = {
  key: string;
  plans: Array<UsersitePlansGetManyPlansTypePayload>;
  queryParams?: string;
};

export type Props = HeaderProps & {
  plans: Plan[];
  businesses: Array<Object>;
  news: Array<ArticleProps>;
};
const Top: VFC<Props> = (props: Props) => {
  const isMounted = useIsMounted();

  useEffect(() => {
    const turbolinks = window.history?.state?.turbolinks;

    if (turbolinks?.restorationIdentifier) {
      const { scrollPosition: { x = 0, y = 0 } = {} } =
        Turbolinks.controller.getRestorationDataForIdentifier(
          turbolinks.restorationIdentifier,
        );
      if (window.scrollY !== y) {
        setTimeout(() => isMounted.current && window.scrollTo(x, y), 200);
      }
    }
  }, [isMounted]);

  return <TopComponent {...props} />;
};

export default Top;
